import React from "react";
import { Skeleton } from 'primereact/skeleton';

export default function SkeletonOrgEmp() {
    return (
        <>
        <div className="d-flex justify-content-center">
            <div className="col-2 m-2">
                <Skeleton height="5rem" width="10rem" className="m-2"></Skeleton>
            </div>
        </div>

        <div className="d-flex justify-content-center">
            <div className="col-2 m-2">
                <Skeleton height="5rem" width="10rem" className="m-2"></Skeleton>
            </div>
            <div className="col-2 m-2">
                <Skeleton height="5rem" width="10rem" className="m-2"></Skeleton>
            </div>
        </div>
        <div className="d-flex justify-content-center">
            <div className="col-2 m-2">
                <Skeleton height="5rem" width="10rem" className="m-2"></Skeleton>
            </div>
            <div className="col-2 m-2">
                <Skeleton height="5rem" width="10rem" className="m-2"></Skeleton>
            </div>
            <div className="col-2 m-2">
                <Skeleton height="5rem" width="10rem" className="m-2"></Skeleton>
            </div>
        </div>
        </>
    )
}